/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';
// @ts-ignore
import type { InvoiceLineProduct } from './InvoiceLineProduct';
// @ts-ignore
import {
// @ts-ignore
    InvoiceLineProductFromJSON,
// @ts-ignore
    InvoiceLineProductFromJSONTyped,
// @ts-ignore
    InvoiceLineProductToJSON,
} from './InvoiceLineProduct';

/**
 * 
 * @export
 * @interface InvoiceLine
 */
export interface InvoiceLine {
    /**
     * 
     * @type {InvoiceLineProduct}
     * @memberof InvoiceLine
     */
    product: InvoiceLineProduct;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    vatRate?: number;
    /**
     * 
     * @type {Amount}
     * @memberof InvoiceLine
     */
    unitPrice: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof InvoiceLine
     */
    lineItemPrice: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof InvoiceLine
     */
    vatAmount: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof InvoiceLine
     */
    totalAmount: Amount;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvoiceLine
     */
    orderIds?: Array<string>;
}

/**
 * Check if a given object implements the InvoiceLine interface.
 */
// @ts-ignore
export function instanceOfInvoiceLine(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "product" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "unitPrice" in value;
    isInstance = isInstance && "lineItemPrice" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "totalAmount" in value;

    return isInstance;
}

// @ts-ignore
export function InvoiceLineFromJSON(json: any): InvoiceLine {
    return InvoiceLineFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceLineFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceLine {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product': InvoiceLineProductFromJSON(json['product']),
        'quantity': json['quantity'],
        'vatRate': !exists(json, 'vat_rate') ? undefined : json['vat_rate'],
        'unitPrice': AmountFromJSON(json['unit_price']),
        'lineItemPrice': AmountFromJSON(json['line_item_price']),
        'vatAmount': AmountFromJSON(json['vat_amount']),
        'totalAmount': AmountFromJSON(json['total_amount']),
        'orderIds': !exists(json, 'order_ids') ? undefined : json['order_ids'],
    };
}

// @ts-ignore
export function InvoiceLineToJSON(value?: InvoiceLine | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product': InvoiceLineProductToJSON(value.product),
        'quantity': value.quantity,
        'vat_rate': value.vatRate,
        'unit_price': AmountToJSON(value.unitPrice),
        'line_item_price': AmountToJSON(value.lineItemPrice),
        'vat_amount': AmountToJSON(value.vatAmount),
        'total_amount': AmountToJSON(value.totalAmount),
        'order_ids': value.orderIds,
    };
}

